import { render, staticRenderFns } from "./invoicesubmissionmanagement-bottom.vue?vue&type=template&id=597ed8a5&scoped=true&"
import script from "./invoicesubmissionmanagement-bottom.vue?vue&type=script&lang=js&"
export * from "./invoicesubmissionmanagement-bottom.vue?vue&type=script&lang=js&"
import style0 from "./invoicesubmissionmanagement-bottom.vue?vue&type=style&index=0&id=597ed8a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ed8a5",
  null
  
)

export default component.exports